// material
import { Container, Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

//
// components
import Page from '../components/Page';
import Scrollbar from '../components/Scrollbar';
import { ProfileForm } from '../components/profile';
import { useTranslation } from '../common/LocalizationProvider';
// ----------------------------------------------------------------------

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  minHeight: '50vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(1, 0)
}));

export default function ProfileUser() {
  const t = useTranslation();

  return (
    <Page title={t('profile_Title')}>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={0}>
          <Typography variant="h4" gutterBottom>
            {t('profile')}
          </Typography>
        </Stack>
        <Scrollbar>
          <ContentStyle>
            <ProfileForm />
          </ContentStyle>
        </Scrollbar>
      </Container>
    </Page>
  );
}
